import { render, staticRenderFns } from "./BindsDivider.vue?vue&type=template&id=303cb3d0&"
import script from "./BindsDivider.vue?vue&type=script&lang=js&"
export * from "./BindsDivider.vue?vue&type=script&lang=js&"
import style0 from "./BindsDivider.vue?vue&type=style&index=0&id=303cb3d0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports